module.exports = __webpack_public_path__ + "static/media/kaleid.55d91e9f.PNG";